export const PRIVY_EMBEDDED_AUTH_RESUME_KEY = "pm:privyEmbeddedAuthResume";
export const PRIVY_EMBEDDED_AUTH_RESUME_TTL_MS = 10 * 60 * 1_000;

function readBrowserSessionStorage() {
  return typeof window === "undefined" ? null : window.sessionStorage;
}

export function markPrivyEmbeddedAuthResume({
  now = Date.now(),
  storage = readBrowserSessionStorage()
} = {}) {
  if (!storage) return false;

  try {
    storage.setItem(PRIVY_EMBEDDED_AUTH_RESUME_KEY, JSON.stringify({ createdAt: now }));
    return true;
  } catch {
    return false;
  }
}

export function clearPrivyEmbeddedAuthResume({ storage = readBrowserSessionStorage() } = {}) {
  if (!storage) return;

  removePrivyEmbeddedAuthResume(storage);
}

function removePrivyEmbeddedAuthResume(storage) {
  try {
    storage.removeItem(PRIVY_EMBEDDED_AUTH_RESUME_KEY);
  } catch {
    // Ignore storage access failures; users can still select Privy wallet again.
  }
}

export function hasPrivyEmbeddedAuthResume({
  now = Date.now(),
  storage = readBrowserSessionStorage()
} = {}) {
  return readPrivyEmbeddedAuthResume({ now, storage, consume: false });
}

export function consumePrivyEmbeddedAuthResume({
  now = Date.now(),
  storage = readBrowserSessionStorage()
} = {}) {
  return readPrivyEmbeddedAuthResume({ now, storage, consume: true });
}

function readPrivyEmbeddedAuthResume({ now, storage, consume }) {
  if (!storage) return false;

  let raw;
  try {
    raw = storage.getItem(PRIVY_EMBEDDED_AUTH_RESUME_KEY);
    if (consume) {
      storage.removeItem(PRIVY_EMBEDDED_AUTH_RESUME_KEY);
    }
  } catch {
    return false;
  }

  if (!raw) return false;

  try {
    const parsed = JSON.parse(raw);
    const createdAt = Number(parsed?.createdAt);
    const valid = Number.isFinite(createdAt) && now - createdAt >= 0 && now - createdAt <= PRIVY_EMBEDDED_AUTH_RESUME_TTL_MS;
    if (!valid && !consume) {
      removePrivyEmbeddedAuthResume(storage);
    }
    return valid;
  } catch {
    if (!consume) {
      removePrivyEmbeddedAuthResume(storage);
    }
    return false;
  }
}
